/**
 * Natraline — Listicle
 * - Compte à rebours de la barre d'annonce (uniquement si une date de fin réelle est renseignée)
 * - Lecture des vidéos clients au clic (une seule vidéo à la fois)
 * Vanilla JS, aucune dépendance. Compatible rechargement de section dans l'éditeur de thème.
 */
(function () {
  'use strict';

  if (window.NatralineListicle) return;

  var ROOT_SELECTOR = '.natraline-listicle';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  /* Accepte "AAAA-MM-JJ" ou "AAAA-MM-JJ HH:MM" (heure locale du visiteur). */
  function parseEndDate(raw) {
    var match = String(raw || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if (!match) return null;
    var hasTime = typeof match[4] !== 'undefined';
    var date = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      hasTime ? Number(match[4]) : 23,
      hasTime ? Number(match[5]) : 59,
      hasTime ? 0 : 59
    );
    return isNaN(date.getTime()) ? null : date;
  }

  function initCountdown(el) {
    if (el.dataset.nlReady) return;
    el.dataset.nlReady = 'true';

    var end = parseEndDate(el.getAttribute('data-nl-countdown'));
    if (!end) return;

    var daysWrap = el.querySelector('[data-nl-days-wrap]');
    var d = el.querySelector('[data-nl-d]');
    var h = el.querySelector('[data-nl-h]');
    var m = el.querySelector('[data-nl-m]');
    var s = el.querySelector('[data-nl-s]');

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        window.clearInterval(el._nlTimer);
        return;
      }
      var total = Math.floor(diff / 1000);
      var days = Math.floor(total / 86400);
      d.textContent = pad(days);
      h.textContent = pad(Math.floor((total % 86400) / 3600));
      m.textContent = pad(Math.floor((total % 3600) / 60));
      s.textContent = pad(total % 60);
      daysWrap.hidden = days === 0;
      el.hidden = false;
    }

    tick();
    el._nlTimer = window.setInterval(tick, 1000);
  }

  function pauseOthers(current) {
    document.querySelectorAll(ROOT_SELECTOR + ' [data-nl-video]').forEach(function (video) {
      if (video !== current && !video.paused) video.pause();
    });
  }

  function initVideo(button) {
    if (button.dataset.nlReady) return;
    button.dataset.nlReady = 'true';

    var card = button.parentElement;
    var video = card && card.querySelector('[data-nl-video]');
    if (!video) return;

    button.addEventListener('click', function () {
      pauseOthers(video);
      video.controls = true;
      card.classList.add('is-playing');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          card.classList.remove('is-playing');
        });
      }
    });

    video.addEventListener('play', function () {
      pauseOthers(video);
      card.classList.add('is-playing');
    });

    video.addEventListener('ended', function () {
      video.controls = false;
      card.classList.remove('is-playing');
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll(ROOT_SELECTOR + ' [data-nl-countdown]').forEach(initCountdown);
    root.querySelectorAll(ROOT_SELECTOR + ' [data-nl-play]').forEach(initVideo);
  }

  function destroy(scope) {
    if (!scope) return;
    scope.querySelectorAll(ROOT_SELECTOR + ' [data-nl-countdown]').forEach(function (el) {
      window.clearInterval(el._nlTimer);
    });
  }

  window.NatralineListicle = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();